import { differenceInCalendarDays } from 'date-fns';

export const calculateDaysFromToday = (backDate: Date): number => {
  return differenceInCalendarDays(new Date(), backDate);
};
